var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"teacher-dashboard"},[_c('show-lesson'),_c('my-lessons'),_c('my-lessons',{attrs:{"pendingLessons":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }